module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAWAgMAAABS7T+rAAAADFBMVEUAAADs7Ozt7e3t7e0zTntkAAAAA3RSTlMAaf4UTMsrAAAAP0lEQVQI1yXJQQHAQAjEwOWzJjBTR1iosztnLZB85hHV110lGOIsKkgwzGxmDgmGnkPPJcEQZ1FBgiHeRQ/oB9EFOK5qmHFzAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/platformIntroduce/sanjiao-down.png
// module id = Fo2T
// module chunks = 70